import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';

import { SectionStatusModel } from '../../models/section-status.model';
import { SectionStatusStore } from './section-status.store';

@Injectable({ providedIn: 'root' })
export class SectionStatusQuery extends Query<SectionStatusModel> {
  protected store: SectionStatusStore;

  selectIrs4506cInfo$ = this.select((state) => state.irs4506cInfo);

  constructor() {
    const store = inject(SectionStatusStore);

    super(store);

    this.store = store;
  }
}
